import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Container } from './../../styles';

export default function Hero(props) {
  const {
    title,
    subtitle,
  } = props;

  return (
    <HeroContainer>
      <HeroBody>
        <Container>
          { title && (
            <HeroTitle>{ title }</HeroTitle> 
          )}

          { subtitle && ( 
            <HeroSubTitle>{ subtitle }</HeroSubTitle> 
          )}
        </Container>
      </HeroBody>
    </HeroContainer>
  );
}

Hero.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  theme: PropTypes.string,
};

const HeroContainer = styled.section`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #fff;
  background-color: #00d1b2;
  background-image: linear-gradient(141deg,#009e6c 0,#00d1b2 71%,#00e7eb 100%);
`;

const HeroBody = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  padding: 3rem 1.5rem;

  @media (min-width: 769px) {
    padding-bottom: 9rem;
    padding-top: 9rem;
  }
`;

const HeroTitle = styled.h1`
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 2.25rem;
  font-weight: 600;
  line-height: 1.125;
`

const HeroSubTitle = styled.h2`
  margin: 0;
  padding: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
`